import React from 'react';
import Draggable from 'react-draggable';
import properties from '../../constants/Properties';
import audioUtils from '../utils/AudioUtils';
import { addStorySound } from '../../actions/ProductionActions';
import { setSlideSoundEffect, changeSlideDuration } from '../../actions/CurrentSlideActions';
import saveManager from '../utils/SaveManager';
import mouseUtils from '../../components/utils/MouseUtils';
import platformDetection from '../../components/utils/PlatformDetection';
import videoUtils from '../../components/utils/VideoUtils';
import durationUtils from '../utils/DurationUtils';
import audioEditorUtils from '../audioEditor/utils/AudioEditorUtils';
import timelineDragManager from '../audioEditor/utils/TimelineDragManager';
import playController from '../utils/PlayController';
import hoverManager from '../utils/HoverManager';
import { changeContextMode, showAudioAlert } from '../../actions/MenuActions';
import audioConverter from '../audioEditor/utils/AudioConverter';
import modeType from '../../constants/ModeConstants';
import storeManager from '../../store/StoreManager';
import appParameters from '../utils/AppParameters';
import localesManager from '../../locales/LocalesManager';

export const SoundItemRenderer = React.createClass({
    getInitialState () {
        return {
            isPlayOver: false,
            isTitleOver: false,
            isPlaying: false,
            clientX: 0,
            clientY: 0,
            element1: undefined
        };
    },
    componentDidMount() {
        audioUtils.initContextSound();
        this.initElements();
    },
    componentWillUnmount() {
        audioUtils.cleanContextSound();
    },
    initElements() {
        const itemStyle = {
            position: 'absolute',
            backgroundColor: 'white',
            width: this.props.accordionWidth,
            height: properties.SOUND_ITEM_HEIGHT,
            top: this.props.index * (properties.SOUND_ITEM_HEIGHT + properties.SOUND_ITEMS_GAP),
            left: 0
        };

        var borderColor;
        var iconColor;
        var backgroundColor = properties.SOUND_ODD_COLOR;

        if (this.props.index % 2 == 0)
            backgroundColor = properties.SOUND_EVEN_COLOR;

        if (this.state.isTitleOver == true) {
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        }
        else {
            iconColor = 'black';
            borderColor = backgroundColor;
        }

        const middlePadding = 10;
        const titleWrapperWidth = this.props.accordionWidth - 2 * properties.EFFECTS_PADDING - properties.SOUND_ITEM_HEIGHT - middlePadding;

        const titleWrapperStyle = {
            width: titleWrapperWidth - 2,
            height: properties.SOUND_ITEM_HEIGHT -2,
            background: backgroundColor,
            position: 'absolute',
            left: properties.EFFECTS_PADDING + properties.SOUND_ITEM_HEIGHT + middlePadding,
            top: 0,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid'
        };

        const durationWidth = 40;
        const padding = 8;
        const fontSize = 13;
        const topPosition = 12;

        const titleStyle = {
            position: 'absolute',
            left: padding,
            top: topPosition,
            width: titleWrapperWidth - 3 * padding - durationWidth,
            fontSize: fontSize,
            cursor: 'default',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        };

        const durationStyle = {
            position: 'absolute',
            right: padding,
            top: topPosition,
            width: durationWidth,
            fontSize: fontSize,
            cursor: 'default',
        };

        const duration = '(' + this.props.value.duration + ')';

        var element1;

        if (platformDetection.isIOS() == true) {
            element1 =
                <span style={titleWrapperStyle} onMouseDown={this.onMouseDown} onMouseUp={this.onTitleMouseUp} onTouchStart={this.onMouseDown} onTouchEnd={this.onTitleMouseUp} onMouseOver={this.onTitleMouseIn} onMouseOut={this.onTitleMouseOut}>
                    <span style={titleStyle}>{this.props.value.title}</span>
                    <span style={durationStyle}>{duration}</span>
                </span>;

            this.setState({
                itemStyle,
                element1
            });
        } else {
            element1 = <span style={titleStyle}>{this.props.value.title}</span>;
            var element2 = <span style={durationStyle}>{duration}</span>;

            this.setState({
                itemStyle,
                element1,
                element2
            });
        }
    },
    getButtonLabel() {
        if (appParameters.locale.indexOf('NO') != -1) {
            if (this.state.isPlaying)
                return localesManager.getCaption('stopp', 'other') + ' ' + this.props.value.title;
            else
                return localesManager.getCaption('spillAv', 'other') + ' ' + this.props.value.title;
        } else {
            if (this.state.isPlaying)
                return localesManager.getCaption('stopp', 'other') + ' ' + this.props.value.title;
            else
                return localesManager.getCaption('spillAv', 'other') + ' ' + this.props.value.title;
        }
    },
    onPlayMouseIn() {
        if (appParameters.locale.indexOf('NO') != -1)
            hoverManager.show(this.refs.play, this.getButtonLabel(), 'top', true);
        else
            hoverManager.show(this.refs.play, 'playSoundItem');

        this.setState({
            isPlayOver: true
        });
    },
    onPlayMouseOut() {
        hoverManager.hide();

        this.setState({
            isPlayOver: false,
            isTitleOver: false
        });
    },
    onTitleMouseIn () {
        this.setState({
            isTitleOver: true
        });
    },
    onTitleMouseOut () {
        this.setState({
            isPlayOver: false,
            isTitleOver: false
        });
    },
    onMouseDown(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        mouseUtils.mouseDownTime = new Date().getTime();

        const clientPosition = mouseUtils.getTouchPosition(e);

        this.setState({
            clientX: clientPosition.x,
            clientY: clientPosition.y
        });
    },
    onTitleMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        if (playController.isAudioEditorAvailable())
            return;

        this.checkSound(e);
    },
    checkSound(e) {
        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 10 && Math.abs(clientPosition.y - this.state.clientY) < 10)
            this.addSound();
    },
    onPlayMouseUp(e) {
        if (mouseUtils.rejectMouseEvent(e))
            return;

        const clientPosition = mouseUtils.getTouchPosition(e);

        if (Math.abs(clientPosition.x - this.state.clientX) < 10 && Math.abs(clientPosition.y - this.state.clientY) < 10)
            this.playSound();
    },
    onTitleClick() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.addSound();
    },
    onPlayClick() {
        var downTime = new Date().getTime() - mouseUtils.mouseDownTime;

        if (downTime < 1000)
            return;

        this.playSound();
    },
    updatePlayingStatus(value) {
        this.setState({
            isPlaying: value
        });

        this.forceUpdate();
    },
    playSound() {
        if (!this.state.isPlaying)
            audioUtils.playSoundFromUrl(this.props.value.href, this.updatePlayingStatus);
        else
            audioUtils.pauseSound('audioBrowserSound');
    },
    addSound() {
        var sound = this.props.value;
        var duration;

        saveManager.isContentChanged(true);

        if (playController.isAudioEditorAvailable()) {
            if (playController.isAudioEditorMode()) {
                playController.getOldScrollPosition();
                audioEditorUtils.addItemToTimeline(sound, this.props.categoryIndex);
            } else {
                playController.toggleAudioEditorMode();

                setTimeout(function() {
                    playController.getOldScrollPosition();
                    audioEditorUtils.addItemToTimeline(sound, this.props.categoryIndex);
                }.bind(this), 50);
            }
        } else {
            if (this.props.isMediaSound == true) {
                this.props.dispatch(setSlideSoundEffect(sound));
                this.props.dispatch(showAudioAlert(1, sound.title));

                // the order for deciding the slide duration for a slide is: video, shape video with the long duration, recorded sound and media/effect sound
                if (!videoUtils.isVideoBackground() && videoUtils.getMaxDurationFromVideoShapes() === 0) {
                    if (sound.duration && !audioUtils.hasSlideSound()) {
                        if (sound.durationInSeconds > 0)
                            duration = sound.durationInSeconds;
                        else
                            duration = durationUtils.transformDurationFromStringToSeconds(sound.duration);

                        if (duration > 0) {
                            this.props.dispatch(changeSlideDuration(duration));

                            audioConverter.addSoundDurationToMap(sound.href, duration);
                        }
                    }
                }
            }
            else {
                this.props.dispatch(addStorySound(sound));
                this.props.dispatch(showAudioAlert(2, sound.title));

                if (sound.durationInSeconds > 0)
                    duration = sound.durationInSeconds;
                else
                    duration = durationUtils.transformDurationFromStringToSeconds(sound.duration);

                if (duration > 0)
                    audioConverter.addSoundDurationToMap(sound.href, duration);
            }

            audioEditorUtils.addActionToHistory();

            if (storeManager.getState().menu.contextMode != modeType.SEARCH_CONTEXT) // if is Search menu then don't hide
                this.props.dispatch(changeContextMode(modeType.CONTEXT_NONE));
        }
    },
    onDrag(e) {
        if (!playController.isAudioEditorAvailable())
            return;

        var target = e.target;

        if (target && target.className && target.className.indexOf('playButton') != -1) {
            timelineDragManager.clearAudioItem();
            return;
        }

        timelineDragManager.startAudioDrag(e, this.props.value);
    },
    onMove(e, coreEvent) {
        if (!playController.isAudioEditorAvailable())
            return;

        timelineDragManager.moveAudio(e, coreEvent);
    },
    onDrop(e, coreEvent) {
        if (!playController.isAudioEditorAvailable())
            return;

        var target = e.target;
        var type = typeof  target.className;

        if (target && target.className && type == 'string' && target.className.indexOf('playButton') != -1) {
            return;
        }

        this.checkSound(e);
        timelineDragManager.endAudioDrag(e, coreEvent);
    },
    shouldComponentUpdate(newProps, nextState) {
        var isPlaying = this.state.isPlaying;

        if (this.state.element1 != nextState.element1 || this.state.isPlayOver != nextState.isPlayOver || this.state.isTitleOver != nextState.isTitleOver || isPlaying != this.state.isPlaying)
            return true;
        else
            return false;
    },
    render() {
        if (this.state ==  undefined || this.state.element1 == undefined)
            return (<div/>);

        var borderColor;
        var iconColor;

        if (this.state.isPlayOver == true) {
            iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
        }
        else {
            iconColor = 'black';
            borderColor = properties.SOUND_EVEN_COLOR;
        }

        var playButtonStyle = {
            width: properties.SOUND_ITEM_HEIGHT - 2,
            height: properties.SOUND_ITEM_HEIGHT - 2,
            background: properties.SOUND_EVEN_COLOR,
            borderRadius: 50,
            position: 'absolute',
            left: properties.EFFECTS_PADDING,
            top: 0,
            borderColor: borderColor,
            borderWidth: 1,
            borderStyle: 'solid'
        };

        var playIconSrc = 'fa fa-play';
        var playIconLeftPosition = 16;

        if (this.state.isPlaying) {
            playIconSrc = 'fa fa-pause';
            playIconLeftPosition = 14;
        }

        const playIconStyle = {
            position: 'absolute',
            top: 11,
            left: playIconLeftPosition - 1,
            color: iconColor
        };

        if (platformDetection.isIOS() == true) {

            return (
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onDrag} onDrag={this.onMove} onStop={this.onDrop}>
                    <div style={this.state.itemStyle}>
                        <div style={playButtonStyle} className={'playButton'} onMouseDown={this.onMouseDown} onMouseUp={this.onPlayMouseUp} onTouchStart={this.onMouseDown} onTouchEnd={this.onPlayMouseUp} onMouseOver={this.onPlayMouseIn} onMouseOut={this.onPlayMouseOut}>
                            <i style={playIconStyle} className={playIconSrc + ' playButton'}></i>
                        </div>
                        {this.state.element1}
                    </div>
                </Draggable>
            );
        } else {
            var backgroundColor = properties.SOUND_ODD_COLOR;

            if (this.props.index % 2 == 0)
                backgroundColor = properties.SOUND_EVEN_COLOR;

            if (this.state.isTitleOver == true) {
                iconColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
                borderColor = properties.SLIDE_VIEWER_BUTTON_SELECTED_COLOR;
            }
            else {
                iconColor = 'black';
                borderColor = backgroundColor;
            }

            const middlePadding = 10;
            const titleWrapperWidth = this.props.accordionWidth - 2 * properties.EFFECTS_PADDING - properties.SOUND_ITEM_HEIGHT - middlePadding;

            const titleWrapperStyle = {
                width: titleWrapperWidth - 2,
                height: properties.SOUND_ITEM_HEIGHT -2,
                background: backgroundColor,
                position: 'absolute',
                left: properties.EFFECTS_PADDING + properties.SOUND_ITEM_HEIGHT + middlePadding,
                top: 0,
                borderColor: borderColor,
                borderWidth: 1,
                borderStyle: 'solid',
                margin: 0,
                padding: 0,
                boxSizing: 'initial',
                fontSize: 'initial',
                textAlign: 'left'
            };

            playButtonStyle.margin = 0;
            playButtonStyle.padding = 0;
            playButtonStyle.boxSizing = 'initial';
            playButtonStyle.fontSize = 'initial';

            var playButtonLabel = this.getButtonLabel();

            return (
                <Draggable axis="none" position={{x:0, y:0}} onStart={this.onDrag} onDrag={this.onMove} onStop={this.onDrop}>
                    <div style={this.state.itemStyle}>
                        <button ref='play' aria-label={playButtonLabel} style={playButtonStyle} className={'playButton'} onClick={this.onPlayClick} onMouseDown={this.onMouseDown} onMouseUp={this.onPlayMouseUp} onTouchStart={this.onMouseDown} onTouchEnd={this.onPlayMouseUp} onMouseOver={this.onPlayMouseIn} onMouseOut={this.onPlayMouseOut}>
                            <i style={playIconStyle} className={playIconSrc + ' playButton'}></i>
                        </button>

                        <button aria-label={this.props.value.title} style={titleWrapperStyle} onClick={this.onTitleClick} onMouseDown={this.onMouseDown} onMouseUp={this.onTitleMouseUp} onTouchStart={this.onMouseDown} onTouchEnd={this.onTitleMouseUp} onMouseOver={this.onTitleMouseIn} onMouseOut={this.onTitleMouseOut}>
                            {this.state.element1}
                            {this.state.element2}
                        </button>
                    </div>
                </Draggable>
            );
        }
    }

});



/** WEBPACK FOOTER **
 ** ./src/components/menus/SoundItemRenderer.js
 **/